import { DateTime } from 'luxon';
import { Translate, useTranslate } from '~/i18n';
import { MyVoucherHistory } from '~/interfaces/vouchers';
import { GreenPlus, RedMinus } from '~/svgs/common';
import { HistoryEmpty } from '~/svgs/vouchers';

type BalanceHistoryProps = {
   balance_history: MyVoucherHistory[];
};

const BalanceHistory = ({ balance_history }: BalanceHistoryProps) => {
   const { lang } = useTranslate();
   return (
      <div className="flex flex-col p-4">
         <div className="mb-3">
            <Translate id="vouchers:balance history" />
         </div>
         {balance_history.length > 0 ? (
            // Balance Exists
            <div className="divide-y divide-gray-300">
               {balance_history.map((history_item, idx) => (
                  <div className="flex py-3" key={idx}>
                     <div className="ltr:mr-4 rtl:ml-4 pt-1.5">
                        {history_item.amount_sign === '+' ? <GreenPlus /> : <RedMinus />}
                     </div>
                     <div className="flex flex-grow flex-col">
                        <div className="flex justify-between text-gray-700">
                           <div>
                              {history_item.action_type === 'Redeem Voucher' ? (
                                 <Translate id="vouchers:redeem voucher" />
                              ) : (
                                 <Translate id="vouchers:book experience" />
                              )}
                           </div>
                           <div className="font-semibold ltr:text-right rtl:text-left">
                              {history_item.amount_sign + ' ' + Math.abs(history_item.amount)}
                              <Translate id="vouchers:sar" />
                           </div>
                        </div>
                        {history_item.amount_sign === '-' && (
                           <div className="text-sm">{history_item.description}</div>
                        )}
                        <div className="text-sm">
                           {DateTime.fromSQL(history_item.created_at)
                              .setLocale(lang?.split('-')[1])
                              .toFormat('dd LLLL yyyy')}
                        </div>
                     </div>
                  </div>
               ))}
            </div>
         ) : (
            // Balance Empty
            <div className="bg-white flex flex-col flex-grow h-36 items-center justify-center my-4 rounded-md space-y-3.5 text-center text-gray-400 text-sm">
               <div>
                  <HistoryEmpty />
               </div>
               <div>
                  <Translate id="vouchers:no balance history" />
               </div>
            </div>
         )}
      </div>
   );
};

export default BalanceHistory;
